import apiClient from "./api";
const PRECIOSESTUDIO_API_BASE_URL = "/preciosEstudio";

class PreciosEStudioService {
  getPrecios() {
    return apiClient.get(PRECIOSESTUDIO_API_BASE_URL);
  }

  savePrecio(precioObj) {
    return apiClient.put(PRECIOSESTUDIO_API_BASE_URL, precioObj);
  }

  reiniciarPrecios(idEstudio) {
    return apiClient.delete(`${PRECIOSESTUDIO_API_BASE_URL}/estudio/${idEstudio}`);
  }

  actualizarPreciosBulk(data) {
    return apiClient.post(`${PRECIOSESTUDIO_API_BASE_URL}/bulk`, data);
  }

}

export default new PreciosEStudioService();
